<div class="dialog-content private-policy-dialog">
  <h1 class="dialog-title">{{  'consent-form.privacy-policy-title' | translate }}</h1>
  
  <button mat-button (click)="close()" class="dialog-close-btn">
    <img src="assets/img/i-close.svg" alt="" />
  </button>

  <div class="scrollable-content">
    <div mat-dialog-content class="inner-content">
      <span class="dialog-subtitle">{{  'consent-form.privacy-policy-content' | translate }}</span>
    </div>
    <div class="list-block">
      <ul>
        <li>{{  'consent-form.privacy-policy-list-title-1' | translate }}
          <p>{{  'consent-form.privacy-policy-list-title-1-1' | translate }}</p>
        </li>
        <li>{{  'consent-form.privacy-policy-list-title-2' | translate }}
          <p>{{  'consent-form.privacy-policy-list-title-2-1' | translate }}</p>
        </li>  
        <li>{{  'consent-form.privacy-policy-list-title-3' | translate }}
          <span>{{  'consent-form.privacy-policy-list-title-3-1' | translate }}
            <ol class="list-num-block">
              <li>{{  'consent-form.privacy-policy-list-title-3-2' | translate }}</li>
              <li>{{  'consent-form.privacy-policy-list-title-3-3' | translate }}</li>
              <li>{{  'consent-form.privacy-policy-list-title-3-4' | translate }}</li>
            </ol>
          </span>
        </li>
        <li>{{  'consent-form.privacy-policy-list-title-4' | translate }}
          <p>{{  'consent-form.privacy-policy-list-title-4-1' | translate }}</p>
        </li>  
      </ul>
    </div>
    <div class="list-two-block">
      <div class="list-two-title-block">
        <h2>{{  'consent-form.private-policy-list-two-title-1' | translate }}</h2>
        <ol>
          <li>{{  'consent-form.private-policy-list-two-title-1-1' | translate }}
            <div class="list-block">
              <ul>
                <li>{{  'consent-form.private-policy-list-two-1-1-1' | translate }}</li>
                <li>{{  'consent-form.private-policy-list-two-1-1-2' | translate }}</li>
                <li>{{  'consent-form.private-policy-list-two-1-1-3' | translate }}</li>
                <li>{{  'consent-form.private-policy-list-two-1-1-4' | translate }}</li>
                <li>{{  'consent-form.private-policy-list-two-1-1-5' | translate }}</li>
                <li>{{  'consent-form.private-policy-list-two-1-1-6' | translate }}</li>
              </ul>
            </div>
          </li>
          <li>{{  'consent-form.private-policy-list-two-title-1-2' | translate }}
            <div class="list-block">
              <ul>
                <li>{{  'consent-form.private-policy-list-two-1-2-1' | translate }}</li>
                <li>{{  'consent-form.private-policy-list-two-1-2-2' | translate }}</li>
                <li>{{  'consent-form.private-policy-list-two-1-2-3' | translate }}</li>
                <li>{{  'consent-form.private-policy-list-two-1-2-4' | translate }}</li>
              </ul>
            </div>
          </li>
        </ol>
        <p>{{  'consent-form.private-policy-list-two-title-1-bottom' | translate }}</p>
      </div>
      <div class="list-two-title-block">
        <h2>{{  'consent-form.private-policy-list-two-title-2' | translate }}</h2>
        <ol>
          <li>{{  'consent-form.private-policy-list-two-title-2-1' | translate }}
            <div class="list-block">
              <ul>
                <li>{{  'consent-form.private-policy-list-two-title-2-1-1' | translate }}</li>
                <li>{{  'consent-form.private-policy-list-two-title-2-1-2' | translate }}</li>
                <li>{{  'consent-form.private-policy-list-two-title-2-1-3' | translate }}</li>
                <li>{{  'consent-form.private-policy-list-two-title-2-1-4' | translate }}</li>
                <li>{{  'consent-form.private-policy-list-two-title-2-1-5' | translate }}</li>
                <li>{{  'consent-form.private-policy-list-two-title-2-1-6' | translate }}</li>
              </ul>
            </div>
          </li>
          <li>{{  'consent-form.private-policy-list-two-title-2-2' | translate }}
            <div class="list-block">
              <ul>
                <li>{{  'consent-form.private-policy-list-two-title-2-2-1' | translate }}</li>
              </ul>
            </div>
          </li>
          <li>{{  'consent-form.private-policy-list-two-title-2-3' | translate }}
            <div class="list-block">
              <ul>
                <li>{{  'consent-form.private-policy-list-two-title-2-3-1' | translate }}</li>
              </ul>
            </div>
          </li>
        </ol>
      </div>
      <div class="list-two-title-block">
        <h2>{{  'consent-form.private-policy-list-two-title-3' | translate }}</h2>
        <ol>
          <li>{{  'consent-form.private-policy-list-two-title-3-1' | translate }}
            <p>{{  'consent-form.private-policy-list-two-title-3-1-text' | translate }}</p>
            <div class="list-block">
              <ul>
                <li>{{  'consent-form.private-policy-list-two-title-3-1-1' | translate }}</li>
                <li>{{  'consent-form.private-policy-list-two-title-3-1-2' | translate }}</li>
                <li>{{  'consent-form.private-policy-list-two-title-3-1-3' | translate }}</li>
                <li>{{  'consent-form.private-policy-list-two-title-3-1-4' | translate }}</li>
              </ul>
            </div>
          </li>
          <li>{{  'consent-form.private-policy-list-two-title-3-2' | translate }}
            <div class="list-block">
              <ul>
                <li>{{  'consent-form.private-policy-list-two-title-3-2-1' | translate }}</li>
                <li>{{  'consent-form.private-policy-list-two-title-3-2-2' | translate }}</li>
              </ul>
            </div>
          </li>
          <li>{{  'consent-form.private-policy-list-two-title-3-3' | translate }}
            <div class="list-block">
              <ul>
                <li>{{  'consent-form.private-policy-list-two-title-3-3-1' | translate }}</li>
                <li>{{  'consent-form.private-policy-list-two-title-3-3-2' | translate }}</li>
              </ul>
            </div>
          </li>
        </ol>
      </div>
      <div class="list-two-title-block-special">
        <h2>{{  'consent-form.private-policy-list-two-title-4' | translate }}</h2>
        <p>{{  'consent-form.private-policy-list-two-title-4-1' | translate }}</p>
        <ol>
          <li>{{  'consent-form.private-policy-list-two-title-4-1-1' | translate }}</li>
          <li>{{  'consent-form.private-policy-list-two-title-4-1-2' | translate }}</li>
          <li>{{  'consent-form.private-policy-list-two-title-4-1-3' | translate }}</li>
          <li>{{  'consent-form.private-policy-list-two-title-4-1-4' | translate }}</li>
          <li>{{  'consent-form.private-policy-list-two-title-4-1-5' | translate }}</li>
          <p>{{  'consent-form.private-policy-list-two-title-4-1-bottom' | translate }}</p>
        </ol>
      </div>
      <div class="list-two-title-block">
        <h2>{{  'consent-form.private-policy-list-two-title-5' | translate }}</h2>
        <ol>
          <li>{{  'consent-form.private-policy-list-two-title-5-1' | translate }}
            <p>{{  'consent-form.private-policy-list-two-title-5-1-text' | translate }}</p>
          </li>
          <li style="font-weight: normal !important;">{{  'consent-form.private-policy-list-two-title-5-2' | translate }}</li>
        </ol>
      </div>
      <div class="list-two-title-block">
        <h2>{{  'consent-form.private-policy-list-two-title-6' | translate }}</h2>
        <ul>
          <li style="font-weight: bold !important;">{{  'consent-form.private-policy-list-two-title-6-1' | translate }}</li>
          <p>{{  'consent-form.private-policy-list-two-title-6-1-text' | translate }}</p>
        </ul> 
      </div>
      <div class="list-two-title-block-2">
        <h2>{{  'consent-form.private-policy-list-two-title-7' | translate }}</h2>
        <p>{{  'consent-form.private-policy-list-two-title-7-text' | translate }}</p>
          <ol>
            <li>{{  'consent-form.private-policy-list-two-title-7-1' | translate }}</li>
            <li>{{  'consent-form.private-policy-list-two-title-7-2' | translate }}</li>
            <li>{{  'consent-form.private-policy-list-two-title-7-3' | translate }}</li>
          </ol>
          <div class="list-block-3">
            <p>{{  'consent-form.private-policy-list-two-title-7-bottom' | translate }}</p>
            <ol>
              <li>{{  'consent-form.private-policy-list-two-title-7-bottom-1' | translate }}</li>
              <li>{{  'consent-form.private-policy-list-two-title-7-bottom-2' | translate }}</li>
              <li>{{  'consent-form.private-policy-list-two-title-7-bottom-3' | translate }}</li>
              <li>{{  'consent-form.private-policy-list-two-title-7-bottom-4' | translate }}</li>
              <li>{{  'consent-form.private-policy-list-two-title-7-bottom-5' | translate }}</li>
              <span>{{  'consent-form.private-policy-list-two-title-7-bottom-6' | translate }}</span>
            </ol>
          </div>
      </div>
    
    </div>
  </div>
  <button type="button" class="btn-fill-primary btn-size-l" (click)="agree($event)">
    {{ 'consent-form.privacy-policy-button' | translate }}
  </button>
</div>
